import { Icons } from '@commenda/kakashi';
import { cn, generateGmailLink } from '@commenda/utils';

export interface HelpAndSupportProps {
  bookCall?: {
    link: string;
  };
  emailUs?: {
    emailId: string;
  };
  className?: string;
}

export function HelpAndSupport({
  bookCall,
  emailUs,
  className,
}: HelpAndSupportProps) {
  return (
    <div
      className={cn(
        'w-[337px] h-fit bg-bg-primary border text-text-tertiary border-border-primary rounded-2xl p-3xl',
        className
      )}
    >
      <div className="flex flex-col gap-xl w-[289px]">
        <h2 className="txt-small-regular">Help & Support</h2>
        {bookCall && (
          <a
            target="_blank"
            rel="noreferrer"
            href={bookCall.link}
            className="txt-small-medium font-medium flex items-center gap-lg border border-border-primary rounded-xl px-2xl py-lg"
          >
            <Icons.User01 className="w-6 h-6" />
            Book a call
          </a>
        )}
        {emailUs && (
          <a
            target="_blank"
            rel="noreferrer"
            href={generateGmailLink(
              emailUs.emailId,
              'Help in Transfer Pricing',
              ''
            )}
            className="txt-small-medium font-medium flex items-center gap-lg border border-border-primary rounded-xl px-2xl py-lg"
          >
            <Icons.Mail01 className="w-6 h-6" />
            <span>
              Write to us at{' '}
              <span className="txt-small-bold">{emailUs.emailId}</span>
            </span>
          </a>
        )}
      </div>
    </div>
  );
}
